import { render, staticRenderFns } from "./FrequencyPage.vue?vue&type=template&id=638d3dd2&scoped=true"
import script from "./FrequencyPage.vue?vue&type=script&lang=js"
export * from "./FrequencyPage.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./FrequencyPage.vue?vue&type=style&index=1&id=638d3dd2&prod&scoped=true&lang=css"
import style2 from "./FrequencyPage.vue?vue&type=style&index=2&id=638d3dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d3dd2",
  null
  
)

export default component.exports